exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[class*=\" el-icon-lx\"],\n[class^=el-icon-lx] {\n  font-family: lx-iconfont!important;\n}", ""]);

// exports
